declare namespace $ {

	export class $mol_icon_repeat extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=repeat.view.tree.d.ts.map